import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * The custom `Team` kind has no built-in entity page content. These cards
 * attach to the catalog's generic entity page, filtered to `kind === 'Team'`,
 * exactly like the org module does for Group's ContactsCard.
 */
const TeamAboutCardExtension = EntityCardBlueprint.make({
  name: 'team-about',
  params: {
    type: 'info',
    filter: entity => entity.kind === 'Team',
    loader: () =>
      import('./TeamAboutCard').then(m => <m.TeamAboutCard />),
  },
});

/**
 * Reuses the org module's ContactsCard: it reads `entity.spec?.contacts` and is
 * kind-agnostic, so a Team carrying `spec.contacts` renders the same block.
 */
const TeamContactsCardExtension = EntityCardBlueprint.make({
  name: 'team-contacts',
  params: {
    type: 'info',
    filter: entity =>
      entity.kind === 'Team' && Boolean(entity.spec?.contacts),
    loader: () =>
      import('../org/ContactsCard').then(m => <m.ContactsCard />),
  },
});

export const teamModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [TeamAboutCardExtension, TeamContactsCardExtension],
});
